import * as React from 'react';
import SiteMapType, { SiteMapLink } from '../../models/siteMap';
import Text from '../Text';
import './style.scss';
import Extend from '../icons/Extend';
import classNames from 'classnames';

interface Props {
  item: SiteMapType;
  index: number;
}

const SiteMapColumn: React.SFC<Props> = ({ item, index }) => {
  const [extended, extend] = React.useState(false);

  return (
    <div key={`${item.title}-${index}`} className={'site-map__column'}>
      <div
        className={'site-map__column__header'}
        onClick={() => extend(!extended)}
      >
        <Text
          type="label"
          color="light"
          weight="bold"
          uppercase
          className={classNames('site-map__column__header__title', 'h5')}
        >
          {item.title}
        </Text>
        <div className={'site-map__column__header__extend'}>
          <Extend extended={extended} />
        </div>
      </div>
      <div
        className={classNames('site-map__column__list', {
          ['site-map__column__list--extended']: extended,
        })}
      >
        {item.links?.map((link: SiteMapLink, index: number) => {
          return (
            <Text
              key={`site-map-column-${link}-${index}`}
              type="h6"
              weight="medium"
              color="light"
              href={link.href}
              linkClassName="dark-mode"
              className={'site-map__column__list__link'}
            >
              {link.title}
            </Text>
          );
        })}
      </div>
    </div>
  );
};

export default SiteMapColumn;
